export default __webpack_public_path__ + "static/media/melk-en-aarbei.4321a96e.png";